export default "__VITE_ASSET__BKttowQ5__"